// extracted by mini-css-extract-plugin
export default {"container":"PriceList_container__6UqmE","wrapper":"PriceList_wrapper__nIJDk","footerStyle":"PriceList_footerStyle__jzOLV"};